// extracted by mini-css-extract-plugin
export var bounce = "_la-1";
export var generatingText = "_la-6";
export var lightning = "_la-4";
export var popup = "_la-5";
export var progressBar = "_la-7";
export var progressFill = "_la-8";
export var progressShimmer = "_la-9";
export var progressText = "_la-a";
export var shimmer = "_la-3";
export var uploadIcon = "_la-0";
export var uploadingText = "_la-2";